import { useCallback } from 'react';
import { config } from 'core/config';
import { appendQueryParams } from '../utils/appendQueryParams';
import { joinUrls } from '../utils/joinUrls';
import { useServices } from './useServices';

export function useRedirectToAskNebula() {
  const { analyticsService, heatmapRecordingService, featureFlags } = useServices();

  const redirectToExternalSignIn = useCallback(
    (
      token: string,
      redirectTo: string,
      params: Partial<{ queryParams: Record<string, unknown> }> = {},
    ) => {
      const { queryParams: passedQueryParams = {} } = params;
      const queryParams = {
        ...passedQueryParams,
        token,
        redirectTo,
        amp_device_id: analyticsService.getDeviceId(),
        split_id: featureFlags.getSplitId(),
      };

      const url = appendQueryParams(joinUrls(config.askNebulaUrl, 'app/external'), queryParams);
      heatmapRecordingService.triggerCustomEvent('user redirect');

      window.location.assign(url);
    },
    [analyticsService, heatmapRecordingService, featureFlags],
  );

  const redirectToQuizCatalogue = useCallback(
    (token: string, params: Partial<{ queryParams: Record<string, unknown> }> = {}) => {
      const { queryParams: passedQueryParams = {} } = params;
      const queryParams = {
        ...passedQueryParams,
        token,
        amp_device_id: analyticsService.getDeviceId(),
        split_id: featureFlags.getSplitId(),
      };

      const url = appendQueryParams(
        joinUrls(config.askNebulaUrl, 'flow/lp/appnebula/experts'),
        queryParams,
      );

      window.location.assign(url);
    },
    [analyticsService, featureFlags],
  );

  const redirectToLogin = useCallback(
    (params: Partial<{ queryParams: Record<string, unknown> }> = {}) => {
      const { queryParams: passedQueryParams = {} } = params;
      const queryParams = {
        ...passedQueryParams,
        amp_device_id: analyticsService.getDeviceId(),
        split_id: featureFlags.getSplitId(),
      };

      const url = appendQueryParams(joinUrls(config.askNebulaUrl, 'app/login'), queryParams);

      window.location.assign(url);
    },
    [analyticsService, featureFlags],
  );

  return {
    redirectToQuizCatalogue,
    redirectToLogin,
    redirectToExternalSignIn,
  };
}
